module.exports = __webpack_public_path__ + "img/error.ab8f793e.svg";